 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		21: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		21: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"a2f0b20087fb3725aaedeb938440a3306208d6cd","1":"64fccfd77509969f359cacf79660d9d1ed658b88","2":"de71a805","3":"c3a5a62471e3ddbab3db941164d5def7e711a641","4":"27e6434b2402a14e128d09835a3b998d55f3ff9e","5":"styles","6":"1bfc9850","7":"framework","8":"196ea373bcbc825bae2809095f88f3804fc6a91b","9":"b2e65308630a40d7029a24983d20f56398345e7d","10":"5e2a4920","11":"c12974d03ffdc601d101aab1c7f05ad2f6d58131","12":"cb16ed3385f32b0f114c7451a05c384fd9fcc074","13":"68bab5c2f467d920ab7ea1dd75772d9b58a1f37e","14":"2e8f77a8b507b9ccc379fc7693c3944d792173af","15":"88b2bc819f658cf4170bc885409f96afdbae30ab","16":"1b404b28ab79dc07c3b6f61c1d07ff237951e496","17":"33f35d011be7f60e35ffd6aece40e573709a40b5","18":"46402fd3d92138c1d1872cbbe7b8f6c70b26d3fa","19":"568e7a258a94bcc7d756eefa060b7e9360cad1ea","20":"be0dba6859ebffbdef212dd88e579da450b1faa6","23":"95b64a6e","25":"component---cache-caches-gatsby-plugin-offline-app-shell-js","26":"component---src-pages-404-js","27":"component---src-pages-about-us-js","28":"component---src-pages-agile-culture-js","29":"component---src-pages-blog-js","30":"component---src-pages-case-studies-js","31":"component---src-pages-contact-us-js","32":"component---src-pages-elements-accordion-js","33":"component---src-pages-elements-box-icon-js","34":"component---src-pages-elements-box-image-js","35":"component---src-pages-elements-box-large-image-js","36":"component---src-pages-elements-button-js","37":"component---src-pages-elements-call-to-action-js","38":"component---src-pages-elements-client-logo-js","39":"component---src-pages-elements-counters-js","40":"component---src-pages-elements-dividers-js","41":"component---src-pages-elements-flexible-image-slider-js","42":"component---src-pages-elements-gradation-js","43":"component---src-pages-elements-lists-js","44":"component---src-pages-elements-message-box-js","45":"component---src-pages-elements-popup-video-js","46":"component---src-pages-elements-social-networks-js","47":"component---src-pages-elements-tabs-js","48":"component---src-pages-elements-team-member-js","49":"component---src-pages-elements-testimonials-js","50":"component---src-pages-elements-timeline-js","51":"component---src-pages-faq-js","52":"component---src-pages-index-js","53":"component---src-pages-it-services-js","54":"component---src-pages-it-solutions-js","55":"component---src-pages-leadership-js","56":"component---src-pages-privacy-policy-js","57":"component---src-templates-author-template-author-template-js","58":"component---src-templates-blog-template-blog-template-js","59":"component---src-templates-case-study-template-case-study-template-js","60":"component---src-templates-category-template-category-template-js","61":"component---src-templates-date-template-date-template-js","62":"component---src-templates-it-solution-template-it-solution-template-js","63":"component---src-templates-search-template-search-template-js","64":"component---src-templates-service-template-service-template-js","65":"component---src-templates-tag-template-tag-template-js"}[chunkId]||chunkId) + "-" + {"0":"918db2f31b9f05fb771d","1":"5dd071f49dc37eb0a17d","2":"be4ebae3fe6dcfdf2aeb","3":"cb7dafa49affd4778153","4":"678839061dd12f6c498a","5":"02afc6442895c97798b1","6":"24af9e2c712cdd6a68d0","7":"b2579a610414d5ff9c4c","8":"5bb8870d6c4431c4ebce","9":"302a182cec31d2734903","10":"95f7a11de47e55830ad5","11":"1219091554b5158d250f","12":"9601490a2e2629a5adb0","13":"3b275c90ccbf1cd1281f","14":"d5804ab2e86a65bd3f6e","15":"7d64f0be8530755fd9f7","16":"f48c6bfdcdb01edeb49e","17":"690c710ef25663c38dc6","18":"a7bacda33b5d5b32cb05","19":"8c5995d047d6cbdbc5bf","20":"fe3d5fb5bb14c84b93fa","23":"9ea0081a93ed20edf9ad","25":"eff09ed32b135e35f061","26":"9bbfd360efeb3ff71849","27":"7b7b65a26a859ab9d251","28":"73fe61a8984004f630f6","29":"e4845dff3d5ce0cbbf90","30":"02a5cbf2cedb58342add","31":"551653456e62ceb4be86","32":"60f62c7b518eb672667c","33":"9d38f333eb4e28d86463","34":"26ffc0b2293b92145280","35":"ece447f702dd26fc1338","36":"e138d96960aef7da8ed4","37":"435c607de70b2647d862","38":"12efe5ded7518c85ca1d","39":"7c6c8bf669778f2a9ec1","40":"6db9564afa295c3e373b","41":"86c0f869bcb5cbeed5bc","42":"81ef2d8ed0c87b4ad747","43":"93ea3944b92afb68fbef","44":"00a9ddaea6181656e9bb","45":"a8234eb1fc92ac9ff4fc","46":"4bb405489fc70defa365","47":"2a6129be26c80aa11202","48":"526fb6ef33961504838f","49":"d8b8b2a512a38af7a7c4","50":"d29456d92b434a75a75e","51":"090fee1dc200aaeff380","52":"35475fbe6d41a707f82f","53":"6d3eed6982df4b4c8cf0","54":"917127a874f7fe9f5109","55":"b92a04dd6ff459b6f79d","56":"616c1b1701245442156f","57":"90e533fddff3b68d90f1","58":"0ba63e6dd83aa92194ce","59":"4e2d8870ba5623c13c47","60":"1b7537d0d3e4c0c91276","61":"9800fa83e9665b0931ba","62":"9da76a0be7ef2638da2f","63":"8176be56a803ef978e06","64":"821e0e88bcadc96c88bd","65":"2d51213163bc5d79fed5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"5":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"a2f0b20087fb3725aaedeb938440a3306208d6cd","1":"64fccfd77509969f359cacf79660d9d1ed658b88","2":"de71a805","3":"c3a5a62471e3ddbab3db941164d5def7e711a641","4":"27e6434b2402a14e128d09835a3b998d55f3ff9e","5":"styles","6":"1bfc9850","7":"framework","8":"196ea373bcbc825bae2809095f88f3804fc6a91b","9":"b2e65308630a40d7029a24983d20f56398345e7d","10":"5e2a4920","11":"c12974d03ffdc601d101aab1c7f05ad2f6d58131","12":"cb16ed3385f32b0f114c7451a05c384fd9fcc074","13":"68bab5c2f467d920ab7ea1dd75772d9b58a1f37e","14":"2e8f77a8b507b9ccc379fc7693c3944d792173af","15":"88b2bc819f658cf4170bc885409f96afdbae30ab","16":"1b404b28ab79dc07c3b6f61c1d07ff237951e496","17":"33f35d011be7f60e35ffd6aece40e573709a40b5","18":"46402fd3d92138c1d1872cbbe7b8f6c70b26d3fa","19":"568e7a258a94bcc7d756eefa060b7e9360cad1ea","20":"be0dba6859ebffbdef212dd88e579da450b1faa6","23":"95b64a6e","25":"component---cache-caches-gatsby-plugin-offline-app-shell-js","26":"component---src-pages-404-js","27":"component---src-pages-about-us-js","28":"component---src-pages-agile-culture-js","29":"component---src-pages-blog-js","30":"component---src-pages-case-studies-js","31":"component---src-pages-contact-us-js","32":"component---src-pages-elements-accordion-js","33":"component---src-pages-elements-box-icon-js","34":"component---src-pages-elements-box-image-js","35":"component---src-pages-elements-box-large-image-js","36":"component---src-pages-elements-button-js","37":"component---src-pages-elements-call-to-action-js","38":"component---src-pages-elements-client-logo-js","39":"component---src-pages-elements-counters-js","40":"component---src-pages-elements-dividers-js","41":"component---src-pages-elements-flexible-image-slider-js","42":"component---src-pages-elements-gradation-js","43":"component---src-pages-elements-lists-js","44":"component---src-pages-elements-message-box-js","45":"component---src-pages-elements-popup-video-js","46":"component---src-pages-elements-social-networks-js","47":"component---src-pages-elements-tabs-js","48":"component---src-pages-elements-team-member-js","49":"component---src-pages-elements-testimonials-js","50":"component---src-pages-elements-timeline-js","51":"component---src-pages-faq-js","52":"component---src-pages-index-js","53":"component---src-pages-it-services-js","54":"component---src-pages-it-solutions-js","55":"component---src-pages-leadership-js","56":"component---src-pages-privacy-policy-js","57":"component---src-templates-author-template-author-template-js","58":"component---src-templates-blog-template-blog-template-js","59":"component---src-templates-case-study-template-case-study-template-js","60":"component---src-templates-category-template-category-template-js","61":"component---src-templates-date-template-date-template-js","62":"component---src-templates-it-solution-template-it-solution-template-js","63":"component---src-templates-search-template-search-template-js","64":"component---src-templates-service-template-service-template-js","65":"component---src-templates-tag-template-tag-template-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"96611f6e738cef12d38b","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
